import styled from "styled-components";
import { Image } from "rebass/styled-components";
import Page from "../components/Page";
import Header from "../components/Header";
import CTA from "../components/CTA";
import About from "../components/About";
import Slogan from "../components/Slogan";
import Footer from "../components/Footer";
import { apiEndpoint } from "../prismic-configuration";
import Prismic from "@prismicio/client";

const ImageBox = styled(Image)`
  padding: 0;
  width: 100%;
  vertical-align: middle;
`;

const DynamicPage = (props) => {
  const { doc, categories, brands } = props;
  const { data } = doc;

  return (
    <Page
      title={"MERLET | " + data.name}
      description="Breed assortiment aan bedrijfs- en promotiekledij met
        de mogelijkheid tot personalisatie."
    >
      <Header />
     

      {data.body.map((body, i) => {
        switch (body.slice_type) {
          case "slogan":
            return (
              <Slogan
                sx={{
                  bg: "gold",
                  pt: "200px",
                }}
                maxWidth="780px"
                data={body}
                key={`slice-${i}`}
              />
            );
          case "content_box":
            return <ContentBoxDynamic data={body} key={`slice-${i}`} />;
          case "title_with_text":
            return <About data={body} key={`slice-${i}`} />;
          case "carousel":
            return (
              <ContentBox>
                <CarouselDynamic
                  itemsPerPage={1}
                  width="90%"
                  maxWidth="996px"
                  mx="auto"
                  data={body}
                  key={`slice-${i}`}
                />
              </ContentBox>
            );
          case "video":
            return (
              <ContentBox>
                <ReactPlayer
                  url={body.primary.video.url}
                  controls={true}
                  width="100%"
                  height="570px"
                  playing
                  light={body.primary.poster_image.url}
                />
              </ContentBox>
            );
          case "cta":
            return <CTA data={body} key={`slice-${i}`} />;
          default:
            return null;
        }
      })}
      <Footer />
    </Page>
  );
};

DynamicPage.getInitialProps = async (context) => {
  const { query } = context;

  const page = await Prismic.client(apiEndpoint).getByUID(
    "page",
    query.pid,
    {}
  );

  return { doc: page };
};

export default DynamicPage;
